// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#Gi2_alerts_group ._div{background:linear-gradient(89deg,#01c2b3,#019fc2);border-radius:4px;color:#fff;font-size:45px;height:200px;margin:3px 10px 10px;text-align:center;width:200px}#Gi2_alerts_group ._div span{font-size:30px;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
